import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-indicator",
  templateUrl: "./kl-indicator.component.html",
  styleUrls: ["./kl-indicator.component.scss"],
})
export class KlIndicatorComponent implements OnInit {
  @Input() show: boolean;

  constructor() {}

  ngOnInit() {}
}
